/**
 * Decisions taken on chat proposal cards in this page session, by tool call.
 *
 * A streamed card's tool output keeps the approvalState it was proposed with,
 * and the card remounts as the chat streams the follow-up turn — so its local
 * state alone would re-offer Accept on a proposal the user already decided.
 * The saved conversation carries the decision after a reload; this covers the
 * live session, and tells other mounted copies of the card.
 */ const decided = new Map();
export const PROPOSAL_DECIDED_EVENT = 'shanks-document-proposal-decided';
export function rememberDecision(toolCallId, d) {
    if (!toolCallId) return;
    decided.set(toolCallId, d);
    window.dispatchEvent(new CustomEvent(PROPOSAL_DECIDED_EVENT, {
        detail: {
            toolCallId,
            decision: d.decision
        }
    }));
}
export function recalledDecision(toolCallId) {
    return toolCallId ? decided.get(toolCallId) : undefined;
}
